import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "m4.586 13 5-5-5-5L6 1.586 12.414 8 6 14.414 4.586 13Z",
		clipRule: "evenodd"
	})
});
export default SvgChevron;
